/**
 * AUTOGENERATED, DO NOT EDIT!
 *
 * https://gitlab.com/digital-pharma-tools/open-api-codegen
 *
 */
export enum CommTypeEnum {
    EMAIL = 'EMAIL',
    SMS = 'SMS',
}